import type { ReactNode } from 'react';
import { Cluster } from '@src/components/Cluster/Cluster';
import { Stack } from '@src/components/Stack/Stack';
import { Typography } from '@src/components/Typography/Typography';
import './Specimens.css';

export interface SpecimensProps {
  label: string;
  note?: string;
  children: ReactNode;
}

/** A labelled row of live examples. */
export function Specimens({ label, note, children }: SpecimensProps) {
  return (
    <Stack gap={3} className="specimens">
      <Cluster align="baseline" gap={3}>
        <Typography as="span" role="meta/caps">
          {label}
        </Typography>
        {note && (
          <Typography as="span" role="meta/helper">
            {note}
          </Typography>
        )}
      </Cluster>
      <Cluster gap={4} wide>
        {children}
      </Cluster>
    </Stack>
  );
}
